import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { DataFlowExpression } from './dataflowexpression';
import { Owned } from '../base/named';
import { IExpressionBasedEntity } from './IExpressionBasedEntity';
import { IMapColumn } from './IMapColumn';
import { TemplateExpressionBasedColumnBase } from './template-expression-based.column.base';

import { ExpressionBasedColumnBase } from './expression-based.column.base';

@Metamodel.model({
    name: 'dataFlowExpressionBasedMapColumn'
})
export class DataFlowExpressionBasedMapColumn extends TemplateExpressionBasedColumnBase implements IExpressionBasedEntity, IMapColumn {
    public static readonly MODEL: IModel;

    public get entityName(): string {
        return this._entityName || this.templateCondition.expression;
    }

    public set entityName(name: string) {
        this._entityName = name;
    }

    /**
     * Whether the column needs to be written or not.
     */
    public writeColumn?: boolean;

    /*
     * The expression for the new column name
     */
    @Metamodel.attribute({
        display: stringResources.Expression,
        constraint: {
            required: true,
            validator: ExpressionBasedColumnBase.expressionIsNotEmptyValidator
        }
    })
    public dataFlowExpression: DataFlowExpression = Owned.create<DataFlowExpression>(DataFlowExpression.MODEL, this);

    private _entityName: string;

    // eslint-disable-next-line no-empty, @typescript-eslint/no-empty-function
    public markDelete(): void { }

}
